import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arrow_right_150.png'
import _imports_1 from '@/assets/icons/group_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-83ac9098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-diagram" }
const _hoisted_2 = { class: "share-rg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "share-living" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "living-icon"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "arrow"
  })
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group" }, " Group ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invite-members" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "member-icon"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "arrow"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("To share your tree, create a "),
  /*#__PURE__*/_createElementVNode("b", null, "group"),
  /*#__PURE__*/_createTextVNode(" and:")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "instructions" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-unstyled" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "step-num" }, "1"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("b", null, "Share"),
      /*#__PURE__*/_createTextVNode(" your tree with the group")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "step-num" }, "2"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("b", null, "Choose"),
      /*#__PURE__*/_createTextVNode(" which living people should be visible")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("span", { class: "step-num" }, "3"),
      /*#__PURE__*/_createTextVNode(),
      /*#__PURE__*/_createElementVNode("b", null, "Invite"),
      /*#__PURE__*/_createTextVNode(" people to join the group")
    ])
  ])
], -1))

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useWorkspaceStore } from '@/rd/WorkspaceStore'
import { workspaceTypeInfos } from '@/rd/ResearchDataModel'
import { useUserStore } from '@/gp/UserStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { FamilyGroup } from '@/gp/GroupAdminModel'
import { LoadMode } from '@/util/AsyncData'
import { isDefined } from '@/util/TypeScriptUtil'
import { minBy } from 'lodash'
import { getPossessive } from '@/util/LanguageUtil'
import Modal from '@/util/Modal.vue'
import { AsyncUtil } from '@/util/AsyncUtil'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareModal',
  setup(__props, { expose: __expose }) {

__expose({
  open: () => modalRef.value?.open(),
})

const router = useRouter()
const dataGroupStore = useDataGroupStore()
const workspaceStore = useWorkspaceStore()
const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()

const researchGroupIconUrlRef = computed(() => {
  const rgs = dataGroupStore.getOwnedResearchGroups(LoadMode.EnsureLoaded)
  if (!rgs.length) // should never happen
    return ''

  const ws = workspaceStore.getAllAsyncWorkspaces(LoadMode.EnsureLoaded)
    .map(a => a.data).filter(isDefined).filter(w => rgs.some(rg => rg.id == w.viewGroupId))
  
  if (!ws.length)
    return ''

  const mostRecentWksp = minBy(ws, w => w.modifiedDate!.valueOf())
  return workspaceTypeInfos.find(t => t.id == mostRecentWksp?.dataFileBaseType)?.icon
})

const modalRef = ref<InstanceType<typeof Modal>>()

async function createFamilyGroup() {  
  try {
    const selfUser = userStore.getAsyncSelf()?.data // should be loaded

    if (selfUser) {
      const fg = new FamilyGroup()
      fg.name = FamilyGroup.getDefaultName(selfUser)
      
      const fgId = await AsyncUtil.atLeast(500, familyGroupStore.addAsync(fg))

      await modalRef.value?.close()
      router.push({ name: 'familyGroup.researchGroupsTab', params: { familyGroupId: fgId} })
    }
  }
  finally {
    // TODO: notify modal not busy
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: createFamilyGroup
  }, {
    title: _withCtx(() => [
      _createTextVNode("Share my tree")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Create a group")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: researchGroupIconUrlRef.value,
            class: "rg-icon"
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _: 1
  }, 512))
}
}

})